import React from 'react';

/* eslint import/no-webpack-loader-syntax: off */
import AlfabankImg from '!url-loader?limit=32768!./logos/AlfaBank.png'
import VisaImg from '!url-loader?limit=32768!./logos/_Visa.png'
import MastercardImg from '!url-loader?limit=32768!./logos/Mastercard-logo.svg-8.png'
import MirImg from '!url-loader?limit=32768!./logos/logo_mir-50.png'
import VisaVerifiedImg from '!url-loader?limit=32768!./logos/_verified-by-visa-40.png'
import MCSecurecodeImg from '!url-loader?limit=32768!./logos/_mastercard-securecode-50.png'
import MirAcceptImg from '!url-loader?limit=32768!./logos/MIRaccept-40.png'

export default function(props) {
    return (
        <React.Fragment>
            <h4>
                Правила оплаты заказа
            </h4>
            <p className="text-block">
                <span>Оплата банковскими картами осуществляется через АО «АЛЬФА-БАНК».</span><br />
            </p>
            <center>
                <img src={AlfabankImg} alt="logo" /><span> </span>
            </center>
                <p className="text-block">
                <span>К оплате принимаются карты VISA, MasterCard, МИР.</span><br />
            </p>
            <center>
                <img src={VisaImg} alt="logo" />
                <img src={MastercardImg} alt="logo" />
                <img src={MirImg} alt="logo" />
            </center>


                <p className="text-block">
                <span>Услуга оплаты через интернет осуществляется в соответствии с Правилами международных платежных систем Visa, MasterCard и Платежной системы МИР на принципах соблюдения конфиденциальности и безопасности совершения платежа, для чего используются самые современные методы проверки, шифрования и передачи данных по закрытым каналам связи. Ввод данных банковской карты осуществляется на защищенной платежной странице АО «АЛЬФА-БАНК».</span><br />
            </p>
                <p className="text-block">
                <span>На странице для ввода данных банковской карты потребуется ввести </span><b><span>данные банковской карты</span></b><span>: номер карты, имя владельца карты, срок действия карты, трёхзначный код безопасности (CVV2 для VISA, CVC2 для MasterCard, Код Дополнительной Идентификации для МИР). Все необходимые данные пропечатаны на самой карте. Трёхзначный код безопасности — это три цифры, находящиеся на обратной стороне карты.</span>
            <br />
            </p>
                <p className="text-block">
                <span>Далее Вы будете перенаправлены на страницу Вашего банка для ввода кода безопасности, который придет к Вам в СМС. Если код безопасности к Вам не пришел, то следует обратиться в банк, выдавший Вам карту.</span><br />
            </p>

            <center>
                <img src={VisaVerifiedImg} alt="logo" />
                <img src={MCSecurecodeImg} alt="logo" />
                <img src={MirAcceptImg} alt="logo" />
            </center>


                <p className="text-block">
                <span>Случаи отказа в совершении платежа: </span><br />
            </p>
                <ul className="list">
                <li className="list__item"><span>банковская карта не предназначена для совершения платежей через интернет, о чем можно узнать, обратившись в Ваш Банк;</span></li>
                <li className="list__item"><span>недостаточно средств для оплаты на банковской карте. Подробнее о наличии средств на банковской карте Вы можете узнать, обратившись в банк, выпустивший банковскую карту;</span></li>
                <li className="list__item"><span>данные банковской карты введены неверно;</span></li>
                <li className="list__item"><span>истек срок действия банковской карты. Срок действия карты, как правило, указан на лицевой стороне карты (это месяц и год, до которого действительна карта). Подробнее о сроке действия карты Вы можете узнать, обратившись в банк, выпустивший банковскую карту;</span></li>
            </ul>
                <p className="text-block">
                <span>По вопросам оплаты с помощью банковской карты и иным вопросам, связанным с работой сайта, Вы можете обращаться по следующим телефонам: </span><b><span><tel>+7 (999) 035-04-85</tel> (с 10 до 18 часов по московскому времени)</span></b><span>.</span>
            <br />
            </p>
                <p className="text-block">
                <span>Предоставляемая Вами персональная информация (имя, адрес, телефон, e-mail, номер банковской карты) является конфиденциальной и не подлежит разглашению. Данные Вашей кредитной карты передаются только в зашифрованном виде и не сохраняются на нашем Web-сервере.</span><br />
            </p>
                <p className="text-block">
                <span> </span><br />
            </p>
                <h3 id="pravila_vozvrata_tovara" className="heading heading_size_m"><span> Правила возврата товара</span></h3>

                <p className="text-block">
                <span>При оплате картами возврат наличными денежными средстВами не допускается. Порядок возврата регулируется правилами международных платежных систем.</span><br />
            </p>
                <p className="text-block">
                <span>
                    Процедура возврата товара регламентируется статьей 26.1 
                    федерального закона «О защите прав потребителей». 
                    Информация о порядке возврата описана в 
                    Публичной оферте.
                </span>
            </p>
                <h3 id="pravila_dostavki_tovara" className="heading heading_size_m"><span> Правила доставки товара</span></h3>

            <p className="text-block">
                Купленные билеты доступны только в электронном виде. Проход на мероприятие производится при предъявлении документа, удостоверяющего личность покупателя.
            </p>
                <p className="text-block">
                <span> </span><br />
            </p>
                <h3 id="kontaktnaja_informatsija" className="heading heading_size_m"><span> Контактная информация</span></h3>

            <p >
                Индивидуальный Предприниматель Кузнецов А.С. <br />
                Юр адрес: 198152, г. Санкт-Петербург, ул. Краснопутиловская, д. 26, кв. 49 <br />
                ИНН 780535004798 <br />
                ОГРНИП 323784700126248 <br />
                Банковские реквизиты: <br />
                р/с 40802810932410011896 <br />
                АО «АЛЬФА-БАНК» <br />
                к/сч 30101810600000000786 <br />
                БИК 044030786 <br />
            </p>
        </React.Fragment>
    );
 };
